import * as React from 'react'
import MouseStates from '../../../utils/MouseStates'

import './styles.css'

type PropsType = {
  MouseStates: MouseStates,
  // positions: {}
}

export default class Dot extends React.Component<PropsType> {

  constructor(props) {
    super(props);
    this.currentTitle = this.props.currentTitle;
    this.time = 0;
  }

  getTitleElementOnHover() {
    return this.currentTitle;
  }

  getValues = () => {
      if(this.props.MouseStates.getResultMatch(this.getTitleElementOnHover()) && this.props.MouseStates.onDotHover) {
        return (
          <animate
            begin="0s"
            dur="5s"
            attributeName="d"
            repeatCount="1"
            fill="freeze"
            calcMode="spline"
            keySplines="0.4 0 0.2 1; 0.4 0 0.2 1"
            values="M26.34,8.66a12.5,12.5,0,1,0,0,17.68,12.5,12.5,0,0,0,0-17.68ZM17.5,19H19V17.5a1.5,1.5,0,0,1-3,0V19h1.5a1.5,1.5,0,0,1,0-3H16v1.5a1.5,1.5,0,0,1,3,0V16H17.5a1.5,1.5,0,0,1,0,3Z;M29.87,5.12a17.5,17.5,0,1,0,0,24.75,17.5,17.5,0,0,0,0-24.75ZM21.5,19H19v2.5a1.5,1.5,0,0,1-3,0V19H13.5a1.5,1.5,0,0,1,0-3H16v-2.5a1.5,1.5,0,0,1,3,0V16h2.5a1.5,1.5,0,0,1,0,3Z;M29.87,5.12a17.5,17.5,0,1,0,0,24.75,17.5,17.5,0,0,0,0-24.75ZM21.5,19H19v2.5a1.5,1.5,0,0,1-3,0V19H13.5a1.5,1.5,0,0,1,0-3H16v-2.5a1.5,1.5,0,0,1,3,0V16h2.5a1.5,1.5,0,0,1,0,3Z"
          />
        )
        
      } else if(!this.props.MouseStates.onDotHover) {
        return "";
      }
  }

  render() {
    return (
      <svg className="read-more" width="35px" height="35px" viewBox="0 0 35 35" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <path d="M26.34,8.66a12.5,12.5,0,1,0,0,17.68,12.5,12.5,0,0,0,0-17.68ZM17.5,19H19V17.5a1.5,1.5,0,0,1-3,0V19h1.5a1.5,1.5,0,0,1,0-3H16v1.5a1.5,1.5,0,0,1,3,0V16H17.5a1.5,1.5,0,0,1,0,3Z" fillRule="nonzero" fill="#fff">
          {this.getValues()}
        </path>
      </svg>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Detail/Dot/index.jsx